import './Space.scss';

export default function Space({ content }) {

    return (
        <div
            className="workshop-space"
            style={{
                height: content.Taille_en_pixel + "px",
            }}
        />
    )
}